import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import { StudioDiamondMark } from '../../StudioMarks';
import { studioCopy } from '../../../../utils/contentCopy';
import StudioCtaRow from '../../StudioCtaRow';
import EditorialFrame, { type EditorialInjectedProps, type EditorialLayoutProps } from './EditorialFrame';

const EditorialCtaContent: React.FC<EditorialInjectedProps & { content: any }> = ({
  content,
  tokens,
  isStory,
  locale,
  qrCodeUrl
}) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();
  const bullets = Array.isArray(content.bullets) ? content.bullets : [];

  return (
    <div>
      {content.kicker ? (
        <div
          style={{
            display: 'inline-block',
            paddingBottom: 5,
            borderBottom: `2px solid ${t.accent}`,
            color: t.accent,
            fontSize: typeSize(isStory ? 10 : 8.5),
            fontWeight: 800,
            letterSpacing: 2.2,
            textTransform: 'uppercase'
          }}
        >
          {content.kicker}
        </div>
      ) : null}
      <h2
        style={{
          maxWidth: 288,
          margin: content.kicker ? (isStory ? '24px 0 0' : '18px 0 0') : 0,
          color: t.ink,
          fontFamily: t.serif,
          fontSize: typeSize(isStory ? 39 : 31),
          fontWeight: 700,
          letterSpacing: '-1.2px',
          lineHeight: 1.18
        }}
      >
        {content.title}
      </h2>
      {content.subtitle ? (
        <p
          style={{
            maxWidth: 278,
            margin: isStory ? '18px 0 0' : '15px 0 0',
            color: t.muted,
            fontFamily: t.serif,
            fontSize: typeSize(isStory ? 14.5 : 12.5),
            fontStyle: 'italic',
            lineHeight: 1.7
          }}
        >
          {content.subtitle}
        </p>
      ) : null}

      {bullets.length ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: isStory ? 13 : 11,
            marginTop: isStory ? 26 : 22,
            color: t.ink,
            fontSize: typeSize(isStory ? 11.5 : 9.8),
            fontWeight: 700
          }}
        >
          {bullets.map((bullet: string, index: number) => (
            <div
              key={`${index}-${bullet}`}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 8
              }}
            >
              <span
                style={{
                  width: 12,
                  flexShrink: 0,
                  display: 'flex',
                  alignItems: 'center',
                  height: '1.6em'
                }}
              >
                <StudioDiamondMark size={10} color={t.accent} />
              </span>
              <span style={{ flex: 1, minWidth: 0, lineHeight: 1.6 }}>{bullet}</span>
            </div>
          ))}
        </div>
      ) : null}

      <StudioCtaRow qrCodeUrl={qrCodeUrl} isStory={isStory} style={{ marginTop: isStory ? 24 : 20 }}>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: isStory ? 12 : 10,
            width: 'fit-content',
            maxWidth: '100%',
            boxSizing: 'border-box',
            padding: isStory ? '15px 17px' : '12px 14px',
            color: '#ffffff',
            background: t.accent,
            fontSize: typeSize(isStory ? 13.5 : 11.5),
            fontWeight: 800,
            letterSpacing: 0.3
          }}
        >
          <span style={{ minWidth: 0, lineHeight: 1.25, overflowWrap: 'anywhere' }}>
            {content.actionLabel || studioCopy.learnMore(locale)}
          </span>
          <span style={{ flexShrink: 0, fontFamily: t.serif, fontSize: typeSize(isStory ? 24 : 19), lineHeight: 0.8 }}>
            →
          </span>
        </div>
      </StudioCtaRow>
    </div>
  );
};

const EditorialCtaLayout: React.FC<EditorialLayoutProps> = props => (
  <EditorialFrame {...props}>
    <EditorialCtaContent content={props.content || {}} />
  </EditorialFrame>
);

export default EditorialCtaLayout;
